import React from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "../utils/helpers";

const FlexItem = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1em;
	background: ${colors.white};
	height: 58px;
	text-align: center;
	flex: 1;
	border-bottom: 1px solid ${colors.grisclaro};
	padding: 0.5em;
	cursor: pointer;
	transition: background 400ms;
	&:hover {
		box-shadow: inset 2px 2px 3px 0px rgba(0, 0, 0, 0.05);
	}
	&:active {
		background: ${colors.white};
	}
	&:not(:first-child) {
		border-left: 1px solid ${colors.grisclaro};
	}
	@media (max-width: 625px) {
		border-left: none;
		height: 40px;
		justify-content: flex-start;
		padding-left: 1.5em;
		&:not(:first-child) {
			border-left: none;
		}
	}
`;

const FlexContainer = styled.section`
	width: 100%;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
	z-index: 1;
	border-top: none;
	@media (min-width: 625px) {
		flex-flow: row;
		border-top: 1px solid ${colors.grisclaro};
	}
`;

const Navegacion = styled.section`
	position: relative;
`;

const pulse = keyframes`
  0% {
	 opacity: 0.5;
	 transform: scale(0.8);
  }
  90% {
	  opacity: 1;
	  transform: scale(1.2);
  }
    100% {
	  opacity: 0.7;
	  transform: scale(0.8);
  }
`;

const FlexItemActivo = FlexItem.extend`
	&:before {
		content: "";
		max-width: 10px;
		max-height: 10px;
		min-width: 10px;
		min-height: 10px;
		background-color: ${colors.main};
		display: inline-block;
		border-radius: 50%;
		margin-right: 0.5em;
		animation: ${pulse} 1s ease-out infinite;
	}
`;

class Pronav extends React.Component {
	handleClick = e => {
		this.props.cambioProcesionActiva(e);
	};

	render() {
		let botonesProcesiones = () => {
			if (this.props.dia === this.props.dia_act) {
				return this.props.tiempo.procesiones.map((x, i) => {
					if (this.props.pro_act.includes(i)) {
						return (
							<FlexItemActivo
								onClick={() => this.handleClick(x)}
								key={x}
								className={this.props.nombre === x ? "nav-active" : ""}
							>
								{x}
							</FlexItemActivo>
						);
					} else {
						return (
							<FlexItem
								onClick={() => this.handleClick(x)}
								key={x}
								className={this.props.nombre === x ? "nav-active" : ""}
							>
								{x}
							</FlexItem>
						);
					}
				});
			} else {
				return this.props.tiempo.procesiones.map((x, i) => {
					return (
						<FlexItem
							onClick={() => this.handleClick(x)}
							key={x}
							className={this.props.nombre === x ? "nav-active" : ""}
						>
							{x}
						</FlexItem>
					);
				});
			}
		};

		return (
			<Navegacion>
				{this.props.dia_act !== 1 &&
				this.props.dia_act !== 2 &&
				this.props.dia_act !== 10 ? (
					<FlexContainer className="flexContainer">
						{this.props.pro_act ? botonesProcesiones() : ""}
					</FlexContainer>
				) : (
					""
				)}
			</Navegacion>
		);
	}
}

export default Pronav;



// WEBPACK FOOTER //
// ./src/components/Pronav.js